export class SizeResolver {
    static getViewportSize() {
        return {
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight,
        };
    }
    static parseValue(value, reference, rootFontSize = 16, elementFontSize = 16) {
        if (typeof value === 'number')
            return value;
        const trimmed = value.toString().trim();
        const match = trimmed.match(/([\d.]+)(px|%|vw|vh|rem|em)?$/);
        if (!match)
            return parseFloat(trimmed) || 0;
        const num = parseFloat(match[1]);
        const unit = match[2] || 'px';
        switch (unit) {
            case 'px':
                return num;
            case '%':
                return (reference * num) / 100;
            case 'vw':
                return (window.innerWidth * num) / 100;
            case 'vh':
                return (window.innerHeight * num) / 100;
            case 'rem':
                return rootFontSize * num;
            case 'em':
                return elementFontSize * num;
            default:
                return num;
        }
    }
    static resolve(size, viewport = this.getViewportSize(), rootFontSize = 16, elementFontSize = 16) {
        return {
            width: this.parseValue(size.width, viewport.width, rootFontSize, elementFontSize),
            height: this.parseValue(size.height, viewport.height, rootFontSize, elementFontSize),
        };
    }
}
//# sourceMappingURL=SizeResolver.js.map